
// region JS Imports

// region External Modules
import $ from "jquery"
import "bootstrap3-tooltip"
import "bootstrap3-popover"
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import MultiDevice from "app/multi_device"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--listings--feature--lister_speaking_languages--badge_with_popover"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`


interface Selector {
  cell:                           string | JQuery | Element,
  lister_speaking_chinese_badge:  string,
}
interface InputSelector {
  cell:                           string | JQuery | Element,
  lister_speaking_chinese_badge?: string,
}
const DEFAULT_SELECTOR = {
  cell:                           ".cell--listings--feature--lister_speaking_languages--badge_with_popover",
  lister_speaking_chinese_badge:  ".cell--listings--feature--lister_speaking_languages--badge_with_popover__lister_speaking_chinese_badge",
}


interface InputOptions {
  popover_options?: Bootstrap3Popover.Options
}
const DEFAULT_POPOVER_OPTIONS = {
  placement:  "auto",
}


class Cell {
  protected selector: Selector

  protected $cell: JQuery
  protected $lister_speaking_chinese_badge: JQuery

  constructor(selector: InputSelector, options?: InputOptions) {
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$cell = $(this.selector.cell as string)
    this.$lister_speaking_chinese_badge = this.$cell.find(this.selector.lister_speaking_chinese_badge)

    if (this.$cell.hasClass(CELL_INITIALIZED_CLASS_NAME)) { return }
    this.$cell.addClass(CELL_INITIALIZED_CLASS_NAME)

    if (MultiDevice.Device.isForDesktop()) {
      const popover_options = Object.assign(
        {},
        DEFAULT_POPOVER_OPTIONS,
        options == null ? {} : options.popover_options,
        {
          content:    "This lister can speak in Chinese only. If you want to exclude this kind of listing, you can filter them by “English Speaking Lister” in your search.",
          trigger:    "hover",
        },
      )
      this.$lister_speaking_chinese_badge.popover(popover_options)
    }
    else {
      const popover_options = Object.assign(
        {},
        DEFAULT_POPOVER_OPTIONS,
        options == null ? {} : options.popover_options,
        {
          content:    "This lister can speak in Chinese only. If you want to exclude this kind of listing, you can filter them by “English Speaking Lister” in your search.",
          trigger:    "manual",
        },
      )
      this.$lister_speaking_chinese_badge.popover(popover_options)

      this.$lister_speaking_chinese_badge.on("click", () => {
        this.$lister_speaking_chinese_badge.popover("show")
      })

      onClickOutside(this.$lister_speaking_chinese_badge[0] as HTMLElement, () => {
        this.$lister_speaking_chinese_badge.popover("hide")
      })
    }
  }
}

const initAllMatchingElements = (options?: InputOptions) => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    new Cell({cell: $(el)}, options)
  })
}

export {
  initAllMatchingElements,
}
